import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { Setup2faComponent } from './auth/2fa/setup-2fa.component';
import { EulaComponent } from './auth/click-through-license/eula.component';
import { ChangePasswordComponent } from './auth/change-password/change-password.component';
import { StartUpMenuComponent } from './start-up-menu/start-up-menu.component';
import { ChosenWorkspaceRedirectComponent } from './chosen-workspace-redirect/chosen-workspace-redirect.component';
import { HomeComponent } from './home/home.component';
import { LandingComponent } from './landing/landing.component';
import { LogoutComponent } from './auth/logout/logout.component';
import { AuthGuard } from './core/auth.guard';

const routes: Routes = [
  {
    path: '',
    component: LandingComponent,
    canActivate: [AuthGuard],
    // all routes which need header should be listed here
    children: [
      {
        path: '',
        component: ChosenWorkspaceRedirectComponent,
      },
      {
        path: 'home',
        component: HomeComponent,
      },
      {
        path: 'change-password',
        component: ChangePasswordComponent,
      },
      {
        path: 'entity-dashboard',
        loadChildren: './entity-dashboard/entity-dashboard.module#EntityDashboardModule',
      },
      {
        path: 'master-file',
        loadChildren: './master-file/master-file.module#MasterFileModule',
      },
      {
        path: 'transaction',
        loadChildren: './transaction/transaction.module#TransactionModule',
      },
      {
        path: 'entity',
        loadChildren: './entity/entity.module#EntityModule',
      },
      {
        path: 'local-files',
        loadChildren: './local-files/local-files.module#LocalFilesModule',
      },
      {
        path: 'wtpr',
        loadChildren: './wtpr/wtpr.module#WtprModule',
      },
      {
        path: 'admin',
        loadChildren: './admin/admin.module#AdminModule'
      },
      {
        path: 'jurisdiction',
        loadChildren: './local-file/jurisdiction-repository/jurisdiction.module#JurisdictionModule',
      }
    ],
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'logout',
    component: LogoutComponent,
  },
  {
    path: 'setup-2fa',
    component: Setup2faComponent,
  },
  {
    path: 'eula',
    component: EulaComponent,
  },
  {
    path: 'start-up-menu',
    component: StartUpMenuComponent
  },
  {
    path: '**',
    redirectTo: '',
  },
];
export const routingModule: ModuleWithProviders = RouterModule.forRoot(routes);
